import Vue from "vue";
import "./plugins/axios";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAnalytics from "vue-analytics";

import feature from "vue-feature-toggle";
import globalMixin from "@/mixins/globalMixin";
import StoreMixin from "./mixins/store.mixin";
import LogRocket from "logrocket";
Vue.config.productionTip = false;

router.beforeEach(async (to, from, next) => {
  if (to.name == "callback" || to.name == "login") {
    // check if "to"-route is "callback" and allow access
    next();
  } else if (store.getters["auth/isAuthenticated"]) {
    if (store.dispatch("auth/checkAuthLevel")) {
      next();
    }

    // if authenticated allow access
  } else {
    // trigger auth0 login
    next("/login");
  }
});
import wysiwyg from "vue-wysiwyg";
Vue.mixin(globalMixin);
Vue.mixin(StoreMixin);
Vue.use(wysiwyg, {
  image: {
    uploadURL: "hhtps://" + process.env.API + "/orders/UploadDealerFiles",
    dropzoneOptions: {}
  }
});

const isDev = process.env.NODE_ENV !== "production";

if (!isDev) LogRocket.init("uotsmx/commissions");

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE,
  router,
  autoTracking: {
    exception: true
    //screenview: true
  },
  debug: {
    enabled: false,
    sendHitTask: true //isProd
  }
});

feature.defaultVisibility(function (rule) {
  return true;
});

feature.visibility("feature1", function (rule) {
  return true;
});

// feature.requiredVisibility(rule => {
//   let visible =
//     typeof visibility[rule.name] === "undefined" ? true : visibility[rule.name];
//   return visible;
// });
feature.showLogs();
Vue.component("feature", feature);
Vue.prototype.$logRocket = LogRocket;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
